import { stringify } from 'query-string';

import timedFetch from 'middleware/timedFetch';

/**
 * Get the Zappos Ask data (questions and answers) for a specified marketplace
 * ID and product ID.
 *
 * @param  string   url             the Zappos Ask service endpoint
 * @param  string   marketId        the obfuscated marketplace ID
 * @param  string   productId       the product ID
 * @param  function [fetcher=fetch] fetch or fetch-like implementation
 * @return object                   promise
 */
function fetchData(url, marketId, productId, fetcher = timedFetch('fetchAskData')) {
  return fetcher(`${url}/questionsAndAnswers/${marketId}${productId}`);
}

/** Fetch the authenticated customer's votes. */
function fetchMyVotes(url, marketId, productId, fetcher = timedFetch('fetchMyAskItemVotes')) {
  const body = JSON.stringify({ marketIdProductId: marketId + productId });
  const opts = { credentials: 'include', method: 'POST', body };
  return fetcher(`${url}/GetCustomerUpvotes`, opts);
}

/**
 * Write a new Ask question or answer. If it's a question, make sure
 * parentItemId is null.
 */
function writeItem(url, marketId, productId, parentItemId, text, fetcher = timedFetch('writeAskItem')) {
  const body = {
    marketIdProductId: `${marketId}${productId}`,
    parentQAItemId: parentItemId || 'NONE',
    text
  };
  const opts = {
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(body)
  };
  return fetcher(`${url}/WriteQAItem`, opts);
}

function changeVote(url, marketId, productId, qAItemId, fetcher, endpoint) {
  const body = JSON.stringify({ marketIdProductId: marketId + productId, qAItemId });
  const opts = { credentials: 'include', method: 'POST', body };
  return fetcher(`${url}/${endpoint}`, opts);
}

/** Vote a question or answer up. */
function upvote(url, marketId, productId, qAItemId, fetcher = timedFetch('upvoteAskItem')) {
  return changeVote(url, marketId, productId, qAItemId, fetcher, 'VoteUp');
}

/** Vote a question or answer down. */
function downvote(url, marketId, productId, qAItemId, fetcher = timedFetch('downvoteAskItem')) {
  return changeVote(url, marketId, productId, qAItemId, fetcher, 'RemoveVoteUp');
}

/** Report a question or answer. */
function reportItem(url, marketId, productId, qAItemId, fetcher = timedFetch('reportAskItem')) {
  const body = JSON.stringify({
    marketIdProductId: marketId + productId,
    qAItemId,
    reportedById: 'police'
  });
  const opts = { credentials: 'include', method: 'POST', body };
  return fetcher(`${url}/ReportQAItem`, opts);
}

function getHmdSurvey(url, { pollId, key }, fetcher = timedFetch('getAskSurvey')) {
  return fetcher(`${url}/GetSurvey?${stringify({ pollId, key })}`);
}

function submitHmdSurvey(url, data, fetcher = timedFetch('getAskSurvey')) {
  return fetcher(`${url}/SubmitSurvey`, {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(data)
  });
}

export default {
  fetchData,
  fetchMyVotes,
  writeItem,
  upvote,
  downvote,
  reportItem,
  getHmdSurvey,
  submitHmdSurvey
};
